import { atom } from 'recoil';

export const scrollableClassState = atom({
  key: 'scrollableClass',
  default: '',
});
